import { uuidv4 } from '../../util/tools';
import { WebSocketEventData, WebSocketEventTypes } from '../custom-event/types';
import { GatewayWebSocketService } from '../web-socket/GatewayWebSocket.service';
import { GatewayRequestType, GatewayResponseType } from '../web-socket/types';

import { BaseSubscriptionRequestType } from './types';

export abstract class BaseSubscriptionService<T> {
  protected readonly gatewayService: GatewayWebSocketService;

  protected token: string;

  protected subscripitonRequests: T[] = [];

  protected constructor(token: string) {
    this.token = token;
    this.gatewayService = GatewayWebSocketService.getInstance(this.token);
    this.gatewayService.addEventListener().subscribe(event => {
      if (event.eventType === WebSocketEventTypes.PARSED_RESPONSE
                && event.data.messageType === this.getResponseType()) {
        this.handleResponseEvent(event);
      }
    });
  }

    protected abstract handleResponseEvent(event: WebSocketEventData<any>): void;

    protected abstract subscribe(item: string, ...args: any[]): void;

    protected abstract subscribeList(item: string[], ...args: any[]): void;

    protected abstract unsubscribe(item: string, ...args: any[]): void;

    protected abstract unsubscribeList(item: string[], ...args: any[]): void;

    protected abstract getSubscriptionRequestType(): GatewayRequestType;

    protected abstract getUnsubscriptionRequestType(): GatewayRequestType;

    protected abstract getResponseType(): GatewayResponseType;

    protected getDefaultRequestParams(): BaseSubscriptionRequestType {
      return {
        messageType: this.getSubscriptionRequestType(),
        traceIdentifier: uuidv4(),
      };
    }
}
